/* eslint-disable react/jsx-indent */
import { Box, Link } from "@mui/material";
import octa from "assets/images/calm.svg";
import trustpilot from "assets/images/missions/mission-eleven/truspilot.svg";
import CustomButton from "components/customButton";
import Panel from "components/missions/Panel";
import useMission from "pages/missionEleven/hooks";

function Trustpilot()
{
	const missionContext = useMission();

	// Render
	return (
		<Box sx={{
			height: "100vh",
			background: "rgba(78, 181, 56, .06)",
			backdropFilter: "blur(40px)",
			width: "100%",
			dsiplay: "flex",
			flexDirection: "column",
			justifyContent: "center"
		}}>
			<Panel sx={{
				// height: missionNumber === 11 ? "auto" : { xl: "585px", lg: "585px", xs: "456px" },
				width: "738px !important",
				margin: "0 auto",
				padding: "32px 32px 32px 32px",
				display: "grid",
				gridTemplateRows: "auto 1fr",
				gap: "24px",
				background: "linear-gradient(103.55deg, rgba(207, 225, 255, 0.55) 9.99%, rgba(223, 223, 223, 0.13) 91.61%) !important",
				boxShadow: "none !important",
				mt: "150px",
				position: "relative"
			}}>
				<Box
					sx={{
						position: "absolute",
						overflow: "hidden",
						bottom: 0,
						right: 0,
						width: "250px", // регулируйте, чтобы контролировать видимую часть
						height: "300px", // регулируйте, чтобы контролировать видимую часть
						zIndex: -1
					}}
				>
					<Box
						component="img"
						src={octa}
						sx={{
							width: "266px",
							transform: "rotate(-36.59deg)",
							position: "absolute",
							right: "-100px", // регулируйте, чтобы сместить изображение внутрь
							bottom: "-230px"
						}}
					/>
				</Box>
				<Box sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center"
				}}>
					<Box sx={{
						color: "#fff",
						font: { xl: "700 40px/51px Lora-Bold", lg: "700 32px/40px Lora-Bold", xs: "700 32px/40px Lora-Bold" },
						textAlign: "center"
					}}>
						Loved your Quest?<br />
						Help others find their path too.
					</Box>
					<Box sx={{
						color: "#fff",
						font: { xl: "400 22px/29px Open Sans", xs: "400 18px/23px Open Sans" },
						textAlign: "center",
						mt: 4,
						mb: 2
					}}>
						Your review on Trustpilot makes a real difference.
					</Box>
					<CustomButton.Contained
						size="large"
						component={Link}
						target="_blank"
						href="https://www.trustpilot.com/review/mylifequest.io"
						sx={{ mt: 6 }}
					>
						Leave review
					</CustomButton.Contained>
					<Box sx={{
						color: "#fff",
						textAlign: "center",
						fontStyle: "italic",
						fontWeight: 300,
						fontSize: { xl: "16px", xs: "16px" },
						lineHeight: { xl: "29px", xs: "23px" },
						fontFamily: "Open Sans"
					}}>
						only takes 2 minutes
					</Box>
					<Box sx={{ background: "#fff", borderRadius: "16px", p: 3, mt: 6 }}>
						<Box
							component="img"
							src={trustpilot}
							sx={{
								width: "211px"
							}} />
					</Box>
				</Box>
			</Panel>
			<Box sx={{ display: "flex", justifyContent: "center", mt: "64px" }}>
				<CustomButton.Contained
					size="large"
					onClick={() => missionContext.setStep((prevState) => prevState + 1)}
					sx={{ background: "#fff", color: "primary.main" }}
				>
					Continue
				</CustomButton.Contained>
			</Box>
		</Box>
	);
}

export default Trustpilot;
